import React from "react";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import "./../stylesheets/components/HeaderNavBar.scss";
import { Link, useLocation } from "react-router-dom";
import { config } from "@frameworks/salesjourney/config/domain";
var HeaderNavBar = function (props) {
    var location = useLocation();
    return (React.createElement(React.Fragment, null,
        React.createElement(Navbar, { sticky: "top", expand: true, className: "d-flex common-header justify-content-between".concat(props.navClassName ? props.navClassName : "") },
            React.createElement(Nav, { className: "d-flex" }, props.list &&
                props.list.map(function (nav, idx) {
                    if (nav.dropDownList) {
                        return (React.createElement(NavDropdown, { title: nav.title, className: "DMSanM_14_500", key: idx }, nav === null || nav === void 0 ? void 0 : nav.dropDownList.map(function (dropDown, idx) {
                            return (React.createElement(NavDropdown.Item, { href: config.applicationFolder + (dropDown === null || dropDown === void 0 ? void 0 : dropDown.route), key: idx }, dropDown === null || dropDown === void 0 ? void 0 : dropDown.title));
                        })));
                    }
                    else {
                        return (React.createElement(Nav.Link, { onClick: function () { return window.scroll(0, 0); }, as: Link, to: nav === null || nav === void 0 ? void 0 : nav.route, className: "DMSanM_14_500 ".concat(nav.route == location.pathname
                                ? //|| (nav.route == "home" && location.pathname == "/home")
                                    "txt-tomato"
                                : ""), key: idx, disabled: nav === null || nav === void 0 ? void 0 : nav.disabled }, nav.title));
                    }
                })),
            props.searchComponent)));
};
export default HeaderNavBar;
